import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Toast, { VARIANT } from '@nykaa/ui-components/Toast';
import { CURRENT_URL, TOAST_TIMER } from '@nykaa/auth-shared/constants';
import useAuthData from '@nykaa/auth-shared/hooks/useAuthData';
import { SCREEN_TYPE } from '@nykaa/auth-shared/store/constants';
import { Inventory } from '@nykaa/auth-shared/store/types';
import { useIsLoggedIn } from 'hooks/auth';
import AdPlatformsScreen from './components/AuthBanners';
import {
  handleAuthRedirection,
  getCurrentStep,
} from '@nykaa/auth-shared/utils';
import ViewToRender from './View';
import { setCurrentUrlForAuth } from 'helpers/auth';
import { LOGIN_ATTEMPT } from 'constants/auth';
import { checkCartCouponsUrl } from 'helpers/utils/url';
import { getEligibleForVariant } from 'helpers/experimentV2';
import { State } from 'store/types';
import { AB_NEW_SHOPPING_BAG } from 'constants/experiments';

interface AuthProps {
  isNudge?: boolean;
  bannerWidgets?: Inventory[];
  signupBannerAdplatformEnabled: boolean;
}

const Auth = ({
  isNudge = false,
  bannerWidgets: bannerWidgets,
  signupBannerAdplatformEnabled,
}: AuthProps) => {
  const history = useHistory();
  const isLoggedIn = useIsLoggedIn();
  const [sucessMessage, setSuccessMessage] = useState('');
  const [flowType, setFlowType] = useState(SCREEN_TYPE.mobileInput);
  const { steps: authStateSteps } = useAuthData();
  const newShoppingBagEnabled =
    useSelector((state: State) =>
      getEligibleForVariant(state, AB_NEW_SHOPPING_BAG, 'A')
    ) || false;

  const handleRedirection = () => {
    const previousPageUrl = window.localStorage.getItem(CURRENT_URL) || '';

    if (
      previousPageUrl &&
      (checkCartCouponsUrl(previousPageUrl, newShoppingBagEnabled) || !isNudge)
    ) {
      window.history.go(-authStateSteps?.length);
    } else {
      handleAuthRedirection();
    }
  };

  useEffect(() => {
    if (isLoggedIn) {
      if (localStorage.getItem(LOGIN_ATTEMPT) === 'true') {
        setTimeout(() => {
          handleRedirection();
        }, 500);
        localStorage.removeItem(LOGIN_ATTEMPT);
      } else handleRedirection();
    } else {
      localStorage.setItem(LOGIN_ATTEMPT, 'true');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn]);

  useEffect(() => {
    const { referrer = '' } = document;
    if (isNudge) {
      setCurrentUrlForAuth();
    } else if (
      referrer.indexOf(window.location.host) >= 0 &&
      referrer.indexOf('/auth') < 0
    ) {
      localStorage.setItem(CURRENT_URL, referrer);
    }
  }, [isNudge]);

  useEffect(() => {
    const stepData = getCurrentStep(authStateSteps, history);
    const { stepName } = stepData || {};
    setFlowType(stepName);
  }, [authStateSteps, history, history?.location?.state]);

  return (
    <>
      {!isNudge && <AdPlatformsScreen />}
      <ViewToRender
        flowType={flowType}
        setSuccessMessage={setSuccessMessage}
        showNudge={isNudge}
        bannerWidgets={bannerWidgets}
        signupBannerAdplatformEnabled={signupBannerAdplatformEnabled}
      />
      {!!sucessMessage && (
        <Toast
          timer={TOAST_TIMER}
          variant={VARIANT.single}
          message={sucessMessage}
        />
      )}
    </>
  );
};

export default Auth;
